<template>
  <ExternalImageWrapper>
    <div v-if="isShowUnsplash||isShowFlaticon || isShowIcon" style="border-top: 1px solid #dee2e6" />
    <div v-if="isShowUnsplash||isShowFlaticon || isShowIcon" class="fs-dbb-20 px-gd-1 mt-gd-1">
      <h5>{{$t('engine.filemanager.freePhoto', languageEngine)}}</h5>
    </div>
    <DirectoryItem
        v-if="isShowUnsplash"
        style="cursor: pointer"
        @click="getUnsplashPhoto"
        class="fs-sa-14 py-5 d-flex align-items-center"
        :class="{
          active: 'unsplash' == selectDirectoryID,
          imageNone: !isShowUnsplash,
        }"
      >
        <span v-show="'unsplash' == selectDirectoryID">
          <i class="fas fa-folder-open"></i>
        </span>
        <span v-show="'unsplash' !== selectDirectoryID">
          <i class="fas fa-folder"></i>
        </span>
        <span class="px-10">{{$t('engine.filemanager.unsplash', languageEngine)}}</span>
    </DirectoryItem>
    <!-- <DirectoryItem
        v-if="isShowFlaticon"
        style="cursor: pointer"
        @click="getFlaticon"
        class="py-5 px-15 d-flex align-items-center"
        :class="{
          active: 'flaticon' == selectDirectoryID,
          imageNone: !isShowFlaticon,
        }"
      >
        <span v-show="'flaticon' == selectDirectoryID">
          <i class="fas fa-folder-open"></i>
        </span>
        <span v-show="'flaticon' !== selectDirectoryID">
          <i class="fas fa-folder"></i>
        </span>
        <span class="pl-10"> Flaticon </span>
    </DirectoryItem> -->
    <!-- <DirectoryItem
        v-if="isShowIcon"
        style="cursor: pointer"
        @click="getIcon"
        class="fs-sa-14  py-5 d-flex align-items-center"
        :class="{
          active: 'icon' == selectDirectoryID,
          imageNone: !isShowIcon,
        }"
      >
        <span v-show="'icon' == selectDirectoryID">
          <i class="fas fa-folder-open"></i>
        </span>
        <span v-show="'icon' !== selectDirectoryID">
          <i class="fas fa-folder"></i>
        </span>
        <span class="px-10">Icon</span>
    </DirectoryItem> -->
  </ExternalImageWrapper>
</template>

<script>
import { ExternalImageWrapper,DirectoryItem } from "./Filemanager.styled";
import { mapGetters } from "vuex";
export default {
  components: {
    ExternalImageWrapper,
    DirectoryItem,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    })
  },
  methods: {
    getUnsplashPhoto() {
      if(this.selectDirectoryID === 'unsplash')return
      this.$emit("getUnsplashPhoto");
    },
    getFlaticon() {
      this.$emit("getFlaticon");
    },
    getIcon() {
      if(this.selectDirectoryID === 'icon')return
      this.$emit("getIcon");
    },
  },
  props: {
    selectDirectoryID: {
      type: [Number, String],
      default: 0,
    },
    siteFileDirectory: {
      type: Array,
      default: () => [],
    },
    isShowUnsplash: {
      type: Boolean,
      default: false,
    },
    isShowFlaticon: {
      type: Boolean,
      default: true,
    },
    isShowIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style></style>
